import { getController } from '@/controllers/request';
import { MODULE } from '@/utils/constants';
import { mixin } from '@/utils/mixins';

export default {
  namespaced: true,
  state: {
    loading: false,
    metadata: {},
    userMetadata: {},
    calendarSettings: {}
  },
  mixins: [mixin],
  mutations: {
    setParam(state, { name, val, param }) {
      if (param) {
        state[name][param] = val;
      } else {
        state[name] = val;
      }
    },
    setLoading(state, value) {
      state.loading = value;
    }
  },
  actions: {
    async fetchCalendarSettings({ commit }) {
      commit('setLoading', true);
      try {
        const params = {
          module: MODULE.HRPAC_CALENDAR,
          action: 'getCalendarSettings'
        };
        const { data } = await getController({ params });
        commit('setParam', { name: 'calendarSettings', val: data });
      } catch (err) {
        console.error(err);
      }
      commit('setLoading', false);
    },
    async fetchCalendarMetadata({ commit }) {
      commit('setLoading', true);
      try {
        const params = {
          module: MODULE.HRPAC_CALENDAR,
          action: 'getCalendarMetadata'
        };
        const { data } = await getController({ params });
        commit('setParam', {
          name: 'metadata',
          val: data.metadata || data.status || null
        });
      } catch (err) {
        console.error(err);
      }
      commit('setLoading', false);
    }
  }
};
